import axios from "../../../services/axios-config";


export async function getLeads(){
    try{
        const res = await axios.get('/leads');

        if(res.status == 200){
            return res.data;
        }

    } catch (error) {
        console.error('ERROR - GET LEADS FUNCTION:', error);
        throw error;
    }
}